import { requestBuilder } from '../../../http/RequestBuilder';
import type { ExternalAccount } from '../../types/BankAccount';

interface UseCreateExternalAccountBody {
    stytchId: string;
    institutionId: string;
    vendorAccessToken: string;
    vendorAccountIds: string[];
}

const useCreateExternalAccount = requestBuilder.mutation<
    ExternalAccount,
    UseCreateExternalAccountBody
>({
    endpoint: '/api/external-account/create',
    method: 'POST',
});

export default useCreateExternalAccount;
